var n=function(t){return t.Customer="customer",t.Escort="escort",t.Attendant="attendant",t}({});export{n as ProfileType};